import React from 'react';
import PropTypes from 'prop-types';
import Navigation from './Navigation';
import SimpleHeader from '../main/headers/simpleHeader';

const Layout = ({ children, title, heading, headerButtons, hideNavigation }) => (
  <div>
    <SimpleHeader heading={heading}>
      <div className="o-flexbox u-align-items-center">
        <div className="u-mr" display-if={!!headerButtons}>
          {headerButtons}
        </div>
        <Navigation title={title} display-if={!hideNavigation} />
      </div>
    </SimpleHeader>
    <div className="c-memberships">
      {children}
    </div>
  </div>
);

Layout.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  heading: PropTypes.string,
  headerButtons: PropTypes.element,
  hideNavigation: PropTypes.bool,
};

Layout.defaultProps = {
  heading: 'Memberships',
  headerButtons: null,
  hideNavigation: false,
};

export default Layout;
